// RequireAuth — route guard for authenticated app pages. Waits on Firebase auth state
// (`loading`) before deciding, so a logged-in user never flashes /login on hard refresh
// (UX-02/06). Signed-out users are sent to /login with an allowlisted ?next deep-link (UX-03).
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth.jsx';
import './Auth.css';

export default function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="vx-auth-loading" role="status" aria-label="Checking your session" />;
  }
  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  return children;
}
